module.exports = __webpack_public_path__ + "media/week-event.png";